import api from "../infrastructure/Api";

export const GetProfessions = () => async (dispatch) => {
    return await api.getCompanyProfessions();
}
